<template>
    <section class="my-page-table">
        <div class="wrapper-charts">
            <div>
                <h3>Vikt</h3>
                <canvas id="weights-chart" data-model="weights" data-label="Vikt" class="line-chart"></canvas>
            </div>

            <div>
                <h3>BMI</h3>
                <canvas id="bmi-chart" data-model="bmis" data-label="BMI" class="line-chart"></canvas>
            </div>
            <div>
                <h3>Midjemått</h3>
                <canvas id="waist-chart" data-model="waist" data-label="Midjemått" class="line-chart"></canvas>
            </div>
            <div>
                <h3>Höftmått</h3>
                <canvas id="hip-chart" data-model="hip" data-label="Höftmått" class="line-chart"></canvas>
            </div>
            <div>
                <h3>Kroppsfett</h3>
                <canvas id="bodyFat-chart" data-model="bodyFat" data-label="Kroppsfett" class="line-chart"></canvas>
            </div>
            <div>
                <h3>Midja/Höft-kvot</h3>
                <canvas id="waistHipRatio-chart" data-model="waistHipRatios" data-label="Midja/Höft-kvot"
                    class="line-chart"></canvas>
            </div>
            <div>
                <h3>Kolesterol</h3>
                <canvas id="cholesterol-chart" data-model="cholesterol" data-label="Kolesterol"
                    class="line-chart"></canvas>
            </div>
            <div>
                <h3>Bukhöjd</h3>
                <canvas id="abdominal-height-chart" data-model="abdominalHeight" data-label="Bukhöjd"
                    class="line-chart"></canvas>
            </div>
            <div>
                <h3>Övre blodtryck</h3>
                <canvas id="blood-pressure-over-chart" data-model="bloodPressureOver" data-label="Övre blodtryck"
                    class="line-chart"></canvas>
            </div>
            <div>
                <h3>Undre blodtryck</h3>
                <canvas id="blood-pressure-below-chart" data-model="bloodPressureBelow" data-label="Undre blodtryck"
                    class="line-chart"></canvas>
            </div>
            <div>
                <h3>Vilopuls</h3>
                <canvas id="resting-pulse-chart" data-model="restingPulse" data-label="Vilopuls"
                    class="line-chart"></canvas>
            </div>
            <div>
                <h3>FettfriKroppsvikt</h3>
                <canvas id="fat-free-chart" data-model="fatFree" data-label="FettfriKroppsvikt"
                    class="line-chart"></canvas>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Datum</th>
                        <th scope="col">Vikt</th>
                        <th scope="col">BMI</th>
                        <th scope="col">Midjemått</th>
                        <th scope="col">Höftmått</th>
                        <th scope="col">Kroppsfett</th>
                        <th scope="col">Midje/Höftkvot</th>
                        <th scope="col">Kolesterol</th>
                        <th scope="col">Vilopuls</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(measurement, index) in state.measurements" :key="measurement.ID">
                        <td>
                            <a href="#" v-on:click.prevent="editWeight(measurement)">{{
                                measurement.Datum
                                }}</a>
                        </td>
                        <td>{{ measurement.Vikt }} kg</td>
                        <td>{{ bmi(measurement) }}</td>
                        <td>
                            {{ measurement.Midjematt ? measurement.Midjematt + ' cm' : '' }}
                        </td>
                        <td>
                            {{ measurement.Hoftmatt ? measurement.Hoftmatt + ' cm' : '' }}
                        </td>
                        <td>
                            {{ measurement.Kroppsfett ? measurement.Kroppsfett + ' %' : '' }}
                        </td>
                        <td>{{ waistHipRatio(measurement) }}</td>
                        <td>{{ measurement.Kolesterol }}</td>
                        <td>{{ measurement.Vilopuls }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>

import state from './../state.js';

import { Chart, LineController, LineElement, PointElement, CategoryScale, LinearScale, Legend, Tooltip } from 'chart.js';

Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Legend, Tooltip);


export default {
    data() {
        return {
            state
        };
    },

    computed: {
        waistHipRatios: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: this.waistHipRatio(val)
                };
            });
        },

        bmis: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: this.bmi(val)
                };
            });
        },

        weights: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.Vikt
                };
            });
        },

        waist: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.Midjematt
                };
            });
        },

        bloodPressureOver: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.BlodtryckOvre
                };
            });
        },

        bloodPressureBelow: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.BlodtryckUndre
                };
            });
        },

        hip: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.Hoftmatt
                };
            });
        },

        bodyFat: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.Kroppsfett
                };
            });
        },

        cholesterol: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.Kolesterol
                };
            });
        },

        abdominalHeight: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.Bukhojd
                };
            });
        },

        restingPulse: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.Vilopuls
                };
            });
        },

        fatFree: function () {
            return this.state.measurementsCharts.map((val) => {
                return {
                    date: val.Datum,
                    val: val.FettfriKroppsvikt
                };
            });
        }
    },

    props: {
        measurements: Array,
        measurementsCharts: Array,
        userLength: Number
    },

    mounted() {
        this.state.measurements = this.measurements;
        this.state.measurementsCharts = this.measurementsCharts;

        const charts = document.querySelectorAll('.line-chart');

        for (const el of charts) {
            // if(this[el.dataset.model].length > 0) {
            //     }

            this.chart(el.id, this[el.dataset.model], el.dataset.label);
            // else {
            //     el.parentElement.remove()
            // }
        }
    },

    methods: {
        bmi: function (measurement) {
            if (measurement.Vikt > 0 && this.userLength > 0) {
                return (measurement.Vikt / ((this.userLength / 100) * (this.userLength / 100))).toFixed(2);
            } else {
                return '';
            }
        },

        waistHipRatio: function (measurement) {
            if (measurement.Midjematt > 0 && measurement.Hoftmatt > 0) {
                return measurement.Midjematt / measurement.Hoftmatt;
            } else {
                return '';
            }
        },

        chart: function (id, array, label) {
            array.sort((a, b) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0));

            const data = {
                labels: array.map((val) => val.date),
                datasets: [
                    {
                        label: label,
                        backgroundColor: 'rgb(255, 99, 132)',
                        borderColor: 'rgb(255, 99, 132)',
                        data: array.map((val) => val.val)
                    }
                ]
            };

            const config = {
                type: 'line',
                data,
                options: {}
            };

            new Chart(document.getElementById(id), config);
        },

        editWeight: function (measurement) {
            $('#add-weight-measurement').modal('toggle');

            for (const [key, value] of Object.entries(measurement)) {
                $('#add-weight-measurement-form input[name="' + key + '"]').val(value);
            }

            const url = new URL(document.location);
            url.searchParams.set('edit', true);
            url.searchParams.set('id', measurement.ID);
            window.history.pushState({}, '', url);
            this.state.isEditMode = true;
        }
    }
};
</script>
